export default "__VITE_ASSET__CSZHJkNb__"